import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import SangliMart from "../../assets/SangliMart.png";
import yash from "../../assets/Yash.png";
import Portfolio from "../../assets/Portfolio.png";
import techalgo from "../../assets/TechAlgo.png";
import aaryans from "../../assets/Aaryans.png";
import ImagineScience from "../../assets/ImagineScience.png"
import github from "../../assets/github.png";
import leetcode from "../../assets/Leetcode.png";

import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
  SiDjango,
  SiCss3,
  SiSqlite,
  SiReact,
  SiNetlify,
  SiWordpress,
  SiPhp,
  SiBootstrap
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different">Projects</h2>
        <div className="allProjects">
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={SangliMart}
                    alt="Rockstar Games"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Sangli Mart</h2>
                <p>
                  Sangli Mart is an Ecommerce Website Built in Django Stack. It has complete options of an Ecommerce Site Including Payment Gateway.
                </p>
                <div>
                  <SiDjango />
                  <SiHtml5 />
                  <SiCss3 />
                  < SiSqlite/>
                  
                </div>
                <div>
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/pratapshingane18/sanglimart"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={yash}
                    alt="Yash Industries"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Yash Industries</h2>
                <p>
                Yash Industries is an Agro-Tech Industry in MIDC Sangli. I am a developer and Developing Website for Yash Industries
                </p>
                <div>
                  <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                </div>
                <div>
                  <a
                    href="https://www.yashindus.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src={Portfolio} alt="" />
                </div>
              </div>
              <div className="project_information">
                <h2>Personal Portfolio</h2>
                <p>
                Created Personal Portfolio to showcase my work and skills. It include my personal Information, Skills,My Journey and My projects along with Links and other info.
                </p>
                <div>
                  <SiReact />
                  <SiTailwindcss/>
                  <SiNetlify />
                </div>
                <div>
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      View 
                    </span>
                  </a>
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={techalgo}
                    alt=""
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Tech-Algo</h2>
                <p>
                 TechAlgo is an Web Application like WIKI built in Django which focuses on various tech algorithms, technologies for comparisons and will help learners to solve their problem.


                </p>
                <div>
                  <SiDjango />
                  <SiWordpress />
                  <SiPhp />
                  
                </div>
                <div>
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      Website
                    </span>
                  </a>
                  <a
                    href="https://drive.google.com/drive/folders/1JiX81OMmS-v8tKsTMiXaM-FsgHSYyaQm?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={aaryans}
                    alt="Team-Aaryans"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Team Aaryans</h2>
                <p>
                I was web Developer at Team Aaryans, Developed Landing Page for Team Aaryans- an automobile Developer Club
                </p>
                <div>
                
                  <SiBootstrap />
                  <SiHtml5 />
                  <DiCss3 />
                </div>
                <div>
                  <a
                    href="https://team-aaryans.github.io/WCE-Sangli/Gallery.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      Visit
                    </span>
                  </a>
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={ImagineScience}
                    alt="PulsePlus-Clone"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Imagine Science</h2>
                <p>
                Developer of Imagine Science Academy of Science and Mathematics Website, Presently Working on Backend Services.
                </p>
                <div>
                  <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                  <SiExpress/>
                  <SiReact/>
                </div>
                <div>
                  <a
                    href="https://imaginescience.in/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      Visit
                    </span>
                  </a>
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={github}
                    alt=""
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Other-Projects</h2>
                <p>
                Other Projects is present on Github, Do Check...


                </p>
               
                <div>
                  <a
                    href="https://github.com/pratapshingane18"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      Check here
                    </span>
                  </a>
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Project
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
       



          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={leetcode}
                    alt=""
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Leetcode profile</h2>
                <p>
                 Check My Leetcode Profile Here
    
                </p>

                
                
                <div>
                  <a
                    href="https://leetcode.com/PratapShingane18/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      Check here
                    </span>
                  </a>
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      My Profile
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
       



        </div>
      </div>
      
    </>
  );
};
